import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoClose } from "react-icons/io5";

const ApproveModal = ({ isOpen, onClose, callbackId, onApprove }) => {
  const [note, setNote] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleApprove = async () => {
    if (!note.trim()) {
      toast.error("Please provide a note for approval");
      return;
    }

    setIsSubmitting(true);
    try {
      await onApprove(callbackId, note);
      setNote("");
      onClose();
    } catch (error) {
      console.error("Error approving callback:", error);
      toast.error("Failed to approve callback");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 transform transition-all duration-300 scale-100">
        <div className="flex flex-wrap gap-3 flex-row md:items-center justify-between border-b border-dashed border-M-text-color/50 pb-2 print-hidden px-4 py-4">
          <h2 className="text-lg font-medium text-black">
            Approve Callback Request
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
            aria-label="Close modal"
          >
            <IoClose />
          </button>
        </div>

        <div className="mb-4 px-4 py-4">
          <label
            htmlFor="note"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Approval Note:
          </label>
          <textarea
            id="note"
            rows={5}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Enter note for approval (e.g., appointment scheduled for...)"
            className="input-field"
            aria-describedby="note-help"
          />
          <p id="note-help" className="text-xs text-gray-500 mt-1">
            Provide details about the approval, such as appointment date or special instructions.
          </p>
        </div>

        <div className="flex justify-end gap-3 px-4 pb-4">
          <button
            onClick={onClose}
            className="bg-[#E7633D]/90 text-sm text-white py-2 px-6 rounded-md hover:bg-[#E7633D] transition-all duration-30"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleApprove}
            className="bg-M-primary-color/90 text-sm text-white py-2 px-6 rounded-md hover:bg-M-primary-color transition-all duration-200"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Processing...
              </>
            ) : (
              "Approve"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApproveModal;